import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/civilLeftImg.png";
import rightimg from "../../../assets/civilRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
// import civilBenefitsImg1 from "../../../assets/civilBenefitsImg1.png";
// import civilBenefitsImg2 from "../../../assets/civilBenefitsImg2.png";
// import civilBenefitsImg3 from "../../../assets/civilBenefitsImg3.png";
// import civilBenefitsImg4 from "../../../assets/civilBenefitsImg4.png";
// import civilBenefitsImg5 from "../../../assets/civilBenefitsImg5.png";
// import civilBenefitsImg6 from "../../../assets/civilBenefitsImg6.png";
// import civilBenefitsImg7 from "../../../assets/civilBenefitsImg7.png";
// import civilBenefitsImg8 from "../../../assets/civilBenefitsImg8.png";
// import civilBenefitsImg9 from "../../../assets/civilBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
// import civilFunActivityImg1 from "../../../assets/CivilFunActivitiesImg1.png";
// import civilFunActivityImg2 from "../../../assets/CivilFunActivitiesImg2.png";
// import civilFunActivityImg3 from "../../../assets/CivilFunActivitiesImg3.png";
// import civilFunActivityImg4 from "../../../assets/CivilFunActivitiesImg4.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";

const CivilEngineeringPortal = () => {
  const CivilEngineeringPage = heroContent.CivilEngineeringPage;

  const foundationModules = [
    {
      title: "Module 1",
      activities: "03",
      classes: "02",
      description:
        "Structures - Understand structural forces by building a bridge with ice cream sticks.",
    },
    {
      title: "Module 2",
      activities: "03",
      classes: "02",
      description:
        "AutoCAD - Learn basic house planning using AutoCAD software.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Explore tools and machines used in construction projects.",
    },
    {
      title: "Module 4",
      activities: "03",
      classes: "02",
      description:
        "Construction Management - Learn how to manage construction processes and phases.",
    },
    {
      title: "Module 5",
      activities: "04",
      classes: "03",
      description:
        "Road Planning & Traffic Symbols - Understand traffic symbols and the role of civil engineers in road planning.",
    },
  ];

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Structures - Learn about structural forces using ETABS software to visualize stress points.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "03",
      description: "AutoCAD - Create medium-level house plans using AutoCAD.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Explore machinery used in small and large construction projects.",
    },
    {
      title: "Module 4",
      activities: "04",
      classes: "03",
      description:
        "Construction Management - Learn construction processes and use Primavera P6 to schedule a house project.",
    },
    {
      title: "Module 5",
      activities: "03",
      classes: "02",
      description:
        "Road Planning & Traffic Symbols - Understand traffic signs and develop a road plan through a real-life scenario project.",
    },
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Structures - Explore structural forces using ETABS and understand their effects on buildings.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "03",
      description:
        "AutoCAD - Design advanced house plans and get introduced to 3D modeling in AutoCAD.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Learn about construction machinery and different types of construction projects.",
    },
    {
      title: "Module 4",
      activities: "04",
      classes: "03",
      description:
        "Construction Management - Understand construction processes and use Primavera P6 to plan a large-scale project.",
    },
    {
      title: "Module 5",
      activities: "03",
      classes: "02",
      description:
        "Road Planning & Traffic Symbols - Study traffic signs and create a road plan based on real-life scenarios.",
    },
    {
      title: "Module 6",
      activities: "03",
      classes: "02",
      description:
        "Soil Mechanics - Discover soil types, classification, and improvement techniques with a practical project.",
    },
  ];

  const benefitsData = [
    {
      title: "Civil Engineering Basics",
      description: "Learn core concepts and structures.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg1.png",
    },
    {
      title: "Logic Skills",
      description: "Use coding blocks to solve problems.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg2.png",
    },
    {
      title: "Creative Thinking",
      description: "Design smart and fun solutions.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg3.png",
    },
    {
      title: "Problem Solving",
      description: "Tackle challenges step-by-step.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg4.png",
    },
    {
      title: "Math & Analysis",
      description: "Improve numeric and data skills.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg5.png",
    },
    {
      title: "Computational Skills",
      description: "Think like a coder and engineer.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg6.png",
    },
    {
      title: "Career Exposure",
      description: "Explore tools used by engineers.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg7.png",
    },
    {
      title: "Confidence & Speaking",
      description:
        "Enhances focus, attention span, and brain agility.Share ideas and present projects.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg8.png",
    },
    {
      title: "STEAM Fun",
      description: "Hands-on learning with real tools.",
      icon: "Polymath-images/Enginerring/civilBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "IceCream Sticks Bridge",
      image: "Polymath-images/Enginerring/Group 22.png",
    },
    {
      title: "Primavera Project Plan",
      image: "Polymath-images/Enginerring/Group 28-1.png",
    },
    {
      title: "AutoCad Floor Plan",
      image: "Polymath-images/Enginerring/Group 22-4.png",
    },
    {
      title: "Construction & equipment Machinery",
      image: "Polymath-images/Enginerring/Group 22-3.png",
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "https://www.youtube.com/embed/iKB_fVIcvmM",
  };

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
            leftImg={"Polymath-images/civilLeftImg.png"}
            rightImg={"Polymath-images/civilRightImg.png"}
            titlePart1="Civil Engineering Course"
            // titlePart2="Unlocking Your Child's Brain Potential"
            description="Polymath-kids offer comprehensive online Civil Engineering course for kids. The online engineering classes' offers two modes-online 1:1 classes and online group classes with trained teachers having years of experience in Civil Engineering."
            button1Text= {false}
            button2Text="Book Free Demo Class"
            button1Icon={'Polymath-images/pencil.png'}
            button2Icon={'Polymath-images/pencil.png'}
            onButton1Click={() => alert("Early bird discount clicked!")}
            onButton2Click={() => alert("Book demo clicked!")}
          />
      {/* <Hero2
        titlePart1={CivilEngineeringPage.titlePart1}
        titlePart2={CivilEngineeringPage.titlePart2}
        description={CivilEngineeringPage.description}
        buttonText={CivilEngineeringPage.buttonText}
        leftImage={'Polymath-images/civilLeftImg.png'}
        rightImage={'Polymath-images/civilRightImg.png'}
      /> */}
      <CourseTimeline
        title1="Course Structure & Syllabus"
        title="Beginner Level Course"
        modules={foundationModules}
      />
      <CourseTimeline
        title="Intermediate Level Course"
        modules={beginnerModules}
      />
      <CourseTimeline title="Advance Level Course" modules={advancedModules} />
      <Benefits
        title="How Students Can Benefit From Civil Engineering Course"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Civil Engineering"
        subTitle="With 40+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default CivilEngineeringPortal;
